import { auth } from './firebase';

export const signOut = async () => {
    return await auth.signOut();
}